import type {LocationQuery, RouteLocationRaw} from 'vue-router';

const PANEL_QUERY_PARAM = 'panel';
const NEW_ORDER_PANEL = 'new-order';

/** Deep link that opens the new order sidepanel, used by the create button in the header. */
export const newOrderPanelRoute: RouteLocationRaw = {
  name: 'orders-overview',
  query: {[PANEL_QUERY_PARAM]: NEW_ORDER_PANEL},
};

export const isNewOrderPanelRequested = (query: LocationQuery): boolean => {
  return query[PANEL_QUERY_PARAM] === NEW_ORDER_PANEL;
};

/** The same query without the panel param, used when the panel closes. */
export const withoutNewOrderPanelQuery = (query: LocationQuery): LocationQuery => {
  const {[PANEL_QUERY_PARAM]: _panel, ...rest} = query;

  return rest;
};
